// src/pages/GameDetailPage.jsx
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import GameBinding from "../components/games/detail/GameBinding";

export default function GameDetailPage() {
  const { gameId } = useParams();          // URL 에서 게임 ID를 꺼냅니다
  const [game, setGame] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!gameId) return;
    setLoading(true);

    (async () => {
      try {
        // Firestore에서 ID로 문서 직접 조회
        const refDoc = doc(db, "games", gameId);
        const snap = await getDoc(refDoc);

        if (snap.exists()) {
          setGame({ id: snap.id, ...snap.data() });
        } else {
          setGame(null);
        }
      } catch (error) {
        console.error(error);
        setGame(null);
      } finally {
        setLoading(false);
      }
    })();
  }, [gameId]);

  if (!gameId) return <div>잘못된 접근입니다.</div>;
  if (loading) return <div>로딩중...</div>;
  if (!game) return <div>게임 정보를 찾을 수 없습니다.</div>;

  return <GameBinding game={game} />;
}
